<template>
	<div class="parkService">
		<div class="parkService__title">
			<p>园区服务</p>
			<div class="parkService__border"></div>
		</div>
		<div class="parkService__service">
			<div v-html="parkServiceContent"></div>
			<div
				v-for="item in parkServiceList"
				:key="item.id"
				class="parkService__article"
			>
				<img :src="item.picture" :alt="item.title" />
				<div>
					<p class="parkService__article--p">
						{{ item.profile }}
					</p>
					<router-link
						tag="div"
						:to="`/HatchingService/parkService/${item.id}`"
					>
						<p class="parkService__article--btn">了解更多</p>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	props: {},
	data() {
		return {}
	},
	computed: {
		...mapState('FHFW', ['parkServiceContent', 'parkServiceList']),
	},
	created() {
		this.fetchParkService({ parkType: 1 })
		this.fetchParkService({ parkType: 2 })
	},
	mounted() {},
	watch: {},
	methods: {
		...mapActions('FHFW', ['fetchParkService']),
	},
	components: {},
}
</script>

<style lang="scss">
.img-ewm {
	margin-left: 70px;
}
</style>
